export default __webpack_public_path__ + "static/media/wasp-hny.a57859fa.png";